import rankLabel from './rankLabel';

export const helpers = {
  rankLabel,
};
